import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=1fb41a41&"
import script from "./ProductsSection.vue?vue&type=script&lang=js&"
export * from "./ProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports